import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { colors as dsColors } from '@modernhealth/vital-foundation';
import { pxToRem } from '../../helpers/pxToRem';
import { ComponentTextMedium } from '../Typography/Typography';
const Wrapper = styled.button(({ selected }) => ({
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
    marginBottom: pxToRem(10),
    width: '100%',
    border: `${pxToRem(2)} solid ${selected ? dsColors.blue : dsColors.lightGrey}`,
    borderRadius: pxToRem(5),
    cursor: 'pointer',
    userSelect: 'none',
    '&:focus-visible': {
        boxShadow: `0px 0px 0px 4px ${dsColors.cyan20}`,
    },
    backgroundColor: 'transparent',
}));
const Name = 'MultiSelectButton';
export const MultiSelectButton = ({ active, text, onClick, className, }) => (_jsx(Wrapper, { className: className, selected: active, onClick: onClick, "data-component": Name, children: _jsx(ComponentTextMedium, { centered: true, children: text }) }));
